// Typelizer digest bb600ce3c328eff3f38430f488747bdb
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/invoices/:invoice_id/settlements */
  create: (
    params: { invoiceId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/invoices/:invoice_id/settlements', params, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/invoices/:invoice_id/settlements/:id */
  destroy: (
    params: { invoiceId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/invoices/:invoice_id/settlements/:id', params, options),
    method: 'delete',
  }),
}
